import type { DraggableChildrenFn, DraggingStyle } from 'react-beautiful-dnd';
import { createPortal } from 'react-dom';

export const useDraggableInPortal = (portalElement: HTMLElement | null) => {
  return (render: DraggableChildrenFn): DraggableChildrenFn =>
    (provided, ...args) => {
      const element = render(provided, ...args);
      const style = provided && provided.draggableProps.style;

      if (style && (style as DraggingStyle).position === 'fixed' && portalElement) {
        return createPortal(element, portalElement) as ReturnType<DraggableChildrenFn>;
      }

      return element;
    };
};
